<template>
  <div class="mb-4">
    <md-card class="s-notification-card">
      <div class="md-layout layout-card">

        <div class="md-layout-item md-size-25 image-content content-normal-screens">
          <div class="notification-thumbs-wrap">
            <div class="first-line-want" :class="[getHeaderBorder]">
              <span class="image-header-text"> Item </span>
            </div>
            <div class="notification-thumb-content" :class="[getImageBorder]">
              <img :src="getItemImagePath(notification)" alt="product" class="main-img fit-contain"
              @click="goToItemDetails(notification)" />
            </div>
          </div>
        </div>
        <div class="md-layout-item md-size-80 image-content content-small-mobile">
          <div class="notification-thumbs-wrap">
            <div class="notification-thumb-content" :class="[getImageBorder]">
              <img :src="getItemImagePath(notification)" alt="product" class="main-img fit-contain"
              @click="goToItemDetails(notification)" />
            </div>
          </div>
        </div>
        <div class="md-layout-item notification-info-content">
          <div class="md-layout layout-top-content">
            <div class="md-layout-item fix-overflow">
              <md-card-header class="md-header-content">
                <div class="second-content-heade">
                  <div class="bottom-line-content">

                    <span @click="goToItemDetails(notification)" class="notification-item-title">
                      {{ notification.item.title }}
                    </span>

                    <div class="md-subhead date-info">
                      <p class="notification-date">{{ notification.changeSituationAt | date }}</p>
                    </div>
                    <p class="notification-text">{{text}}</p>
                  </div>
                </div>
              </md-card-header>
            </div>
          </div>

          <div class="buttons-container">
            <div class="notification-action active messages" @click="openChat()">
              <SButtonMaterial svgIcon="/svg-icons/rounded-message-icon.svg" :iconWithoutText="true"
                color="transparent" materialClass="dense"
              />
              Messages
            </div>
          </div>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>


import ItemHelperVue from "../../mixins/ItemHelper.vue";
import itemType from "@/enum/item-type";
import UserHelperVue from "../../mixins/UserHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";

export default {
  name: "NotificationsList",
  props: ["notification", "text"],
  mixins: [UserHelperVue, ItemHelperVue],
  components: {
    SButtonMaterial,
  },
  data() {
    return {
    };
  },
  methods: {
    goToItemDetails(notification) {
      this.$router.push(`/s-app/item-details/${notification.item.id}`);
    },
    openChat() {
      this.$router.push(`/s-app/message-center`);
    },
  },
  computed: {
    getImageBorder() {
      let type = this.notification?.item.type ?? "";
      return type === itemType.GIVE || type === itemType.LEND
        ? "border-image-tertiary"
        : "border-image-offer";
    },
    getHeaderBorder() {
      let type = this.notification?.item.type ?? "";
      return type === itemType.GIVE || type === itemType.LEND
        ? "border-header-tertiary"
        : "border-header-offer";
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.md-button {
  min-width: unset !important;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 15px;
}

.border-image-tertiary {
  margin-top: 0 !important;
  border: 3px solid $tertiary;
  box-sizing: border-box;
}

.border-image-offer {
  border: 3px solid $offer;
}
.border-header-tertiary {
  margin-top: 0 !important;
  border: 3px solid $tertiary;
  box-sizing: border-box;
  background-color: $tertiary;
}
.border-header-offer {
  border: 3px solid $offer;
  background-color: $offer;
}
.layout-top-content {
  height: 75%;
}
.s-notification-card {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  height: 230px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.image-content {
  align-self: center;
  margin-left: 1rem;
}
.notification-thumbs-wrap {
  padding: 0.3rem;
  padding-bottom: 0.5rem;
}
.notification-thumb-content {
  height: 180px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.main-img {
  background: transparent !important;
  height: 100%;
}
</style>

<style lang="scss" scoped>
/* style for header */
.md-header-content,
.notification-info-content {
  max-width: 70%;
}
.fix-overflow {
  overflow: hidden;
  min-width: 55%;
  max-width: 100%;
  flex: 0 1 100%;
  text-overflow: ellipsis;
}
.second-content-heade {
  max-width: 100%;
}
.bottom-line-content {
  text-overflow: ellipsis;
  overflow: hidden;
}
.date-info {
  color: $black !important;
  opacity: 1;
  margin-top: 5px;
}
</style>

<style lang="scss" scoped>
.first-line-want {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.image-header-text {
  font-weight: 400;
  color: white;
}
.notification-item-title {
  font-weight: 500;
  font-size: 22px;
  margin-bottom: 5px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 150px; // some width
  text-align: center;
}
.notification-text {
  font-size: 18px;
  color: gray;
}
.request-trade-type {
  font-weight: 700;
  text-transform: uppercase;
}
.notification-action {
  width: 48% !important;
  max-height: 44px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 16px;
}
.notification-action.messages {
  margin-left: auto;
}
.notification-action.active {
  cursor: pointer;
  background-color: $primary;
}
.notification-action.disabled {
  background-color: rgba(0, 0, 0, 0.38);
}
</style>

<style lang="scss" scoped>
/* style for responsive content */
@media screen and (max-width: 541px) {
  .content-normal-screens {
    display: none;
  }

  .notification-info-content {
    max-width: 95%;
  }

  .s-notification-card {
    height: 460px;
    padding-top: 2rem;
  }
  .notification-thumb-content {
    justify-content: center;
  }

  .layout-card {
    justify-content: center;
  }

  .notification-item-title {
    width: 100px;
  }

  .date-info {
    display: flex;
    flex-direction: column;
  }

  .layout-top-content {
    margin-bottom: 1rem;
  }
}

@media screen and (min-width: 541px) {
  .content-small-mobile {
    display: none;
  }
}

@media screen and (min-width: 769px) and (max-width: 1023px) {
  .notification-thumb-content {
    height: 150px;
  }
}

@media screen and (min-width: 541px) and (max-width: 768px) {
  .notification-thumb-content {
    height: 130px;
  }

  .date-info {
    font-size: 12px;
  }


  .notification-item-title {
    font-size: 16px;
    width: 100px;
  }

  .first-line-want {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
